import { useEffect } from 'react';

let locks = 0;
let y = 0;
let prev: { overflow: string; position: string; top: string; width: string } | null = null;

export function lockBodyScroll() {
  if (locks++ === 0) {
    y = window.scrollY;
    prev = {
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
    };
    document.body.style.overflow = 'hidden';
  }
}

export function unlockBodyScroll() {
  locks = Math.max(0, locks - 1);

  if (locks === 0 && prev) {
    document.body.style.overflow = prev.overflow;
    document.body.style.position = prev.position;
    document.body.style.top = prev.top;
    document.body.style.width = prev.width;
    window.scrollTo(0, y);
    prev = null;
  }
}

export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;

    lockBodyScroll();

    return () => unlockBodyScroll();
  }, [active]);
}
